
import { setError } from "../features/errorSlice";
import { store } from "../app/store";
import { deleteCookie, getCookie, normalizeDates } from "../helpers/helper";
const host = window.location.host.indexOf(':3000') > -1 ? process.env.REACT_APP_API_HOST : window.location.protocol + '//'+ window.location.host
 // e.g., http://localhost:5000
const MAX_RETRIES = 1
const endpoints = {
  rents: `${host}/api/rentals`,
  tenants: `${host}/api/tenants`,
  agreements: `${host}/api/agreements`,
  invoices: `${host}/api/invoices`,
  filters:`${host}/api/filters`,
  forms:`${host}/api/forms`,
  auth: `${host}/api/auth`,
  workspace: `${host}/api/workspace`,
  events:`${host}/api/events`,
  invoicebuilder:`${host}/api/invoicebuilder`,
  leads:`${host}/api/leads`,
  preload:`${host}/api/preload`,
  stats:`${host}/api/stats`,
  users:`${host}/api/users`,
  bulkaction:`${host}/api/bulkaction`,
  availability:`${host}/api/availability`,
  productpage:`${host}/api/productpage`,
};


/*

having a inbuilt cache for 45s to prevent network calls majorly during filters
we clear all cache on the first write operation

*/
const TTL = 45 * 1000;

const cache = new Map();     // key → { data, expiresAt }


function classifyAction(api , action ){
  if(api.indexOf('template') > -1){
    return "read"
  }
  if(api.endsWith('stats') || api.endsWith("preload")){
    return 'read'
  }
  if (
    action.toLowerCase().startsWith("get") ||
    action.toLowerCase().startsWith("select") ||
    action.toLowerCase().startsWith("fetch")
  ) {
        return 'read'
  }
  return 'write'

}
const isFormData = (v) => (typeof FormData !== "undefined") && (v instanceof FormData);
function getCacheKey(url, payload) {
  return `${url}:${JSON.stringify(payload)}`;
}
/**
 * Generic API action handler for add, delete, update, getAll, getById
 * @param {'rents'|'tenants'|'agreements'|'invoices'|'filters'|'forms'|'auth'|'workspace'|'events'|'invoicebuilder'|'preload'|'raw'} key
 * @param {object} body - data to send
 * @param {'add'|'delete'|'update'|'getAll'|'getById'|'getUniqueInField'} action - action type
 * @returns {Promise<any>} - API response data
 */
export async function apiAction(key, body = {}, action , retry=0) {
  let url = endpoints[key];
  let method = "POST";
  if (key == 'auth' && (action == 'logout' || action == 'switch_workspace')){
    cache.clear()
    if(action == "switch_workspace"){
      return
    }
  }

  if (key === "raw") {
    method = body?.method || "GET";
    delete body.method;

    url = host + (body?.url || "");
    delete body.url;
  }

  if (!url) throw new Error(`Invalid endpoint key: ${key}`);

  // Prepare headers
  const headers = {
    "Content-Type": "application/json",
  };


  const tempToken = getCookie("tempAuthToken");
  const workspaceData = sessionStorage.getItem("selectedWorkspace");

  // Prioritize scoped token, fall back to temp token
  const token =  tempToken;
  if (token) headers["Authorization"] = `Bearer ${token}`;

  if (workspaceData) {
    try {
      headers["x-workspace-id"] = workspaceData;
    } catch (e) {
      console.error("Failed to use workspace data from localStorage", e);
    }
  }

  // Arrange the request body based on action & method
  let postData = { action, ...body };
  postData = normalizeDates(postData)
  const reqData = {
    method,
    headers,
  };

  // Include body for methods that support it
if (isFormData(body)) {
    reqData.body = body;
    delete reqData.headers["Content-Type"];
  } else if (body && body.file instanceof File) {

    const fd = new FormData();
    fd.append("file", body.file, body.file.name);
    for (const [k, v] of Object.entries(body)) {
      if (k === "file") continue;
      if (v !== null && typeof v === "object") fd.append(k, JSON.stringify(v));
      else fd.append(k, v == null ? "" : String(v));
    }
    if (!fd.has("action") && action) fd.append("action", action);
    reqData.body = fd;
    delete reqData.headers["Content-Type"];
  } else {
    reqData.headers["Content-Type"] = "application/json";
    if (["POST", "PUT", "PATCH", "DELETE"].includes(method.toUpperCase())) {
      reqData.body = JSON.stringify(postData);
    }
  }
  const actionType = classifyAction(url , action)
  const cacheKey = getCacheKey(url,reqData.body)
  let cacheHit = false
  let response = {}
  if (actionType === "read"){
    if (cache.has(cacheKey)){
      const ret = cache.get(cacheKey)
      if (ret.expiresAt > Date.now()){
        return JSON.parse(JSON.stringify(ret.data))

      }
    }
  } else {
    cache.clear()
  }
  try {
    if (!cacheHit){
      response = await fetch(url, reqData);
    // Handle unauthorized globally
    if (response.status === 401) {
      // kill any stale auth state
      deleteCookie('tempAuthToken')

      // hard redirect
      window.location.href = '/login';
      return; // stop further execution
    }





    // Parse by content-type
    const contentType = response.headers.get("content-type") || "";
    let parsed;

    if (contentType.includes("application/json")) {
      parsed = await response.json();
    } else if (contentType.startsWith("text/") || contentType.includes("text/plain")) {
      parsed = await response.text();

    } else {
      if (['generate','download','view'].indexOf(action) > -1){
      // Fallback for files/binaries (e.g., PDFs)
      parsed = await response.blob();
      const url = URL.createObjectURL(parsed);
      window.open(url);
      return
      }
    }
    if(parsed && parsed.code){
        store.dispatch(setError(parsed.code))
        throw {data:parsed ,code : parsed.code}

    }
    if (!response.ok || response.code) {
      // Keep the parsed body for error handling upstream
        throw { data: parsed, status: response.status };
      }
    cache.set(cacheKey,{data:JSON.parse(JSON.stringify(parsed)),expiresAt:Date.now()+TTL})
    return parsed;
    }

  } catch (error) {
    // Re-throw for the caller to handle (e.g., in thunks)
    if (error.data) error = error.data
    if(!error.code){

      store.dispatch(setError("Unknown Error Occured, Contact Support"))
      throw new Error(error.code || error.message || 'Unknown Error')
    }
    throw new Error(error.code || error.message || 'Known Error')




  }
}

export default apiAction;
